export const peselMask = [
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  /\d/,
];

export const postalCodeMask = [/\d/, /\d/, "-", /\d/, /\d/, /\d/];

export const ocNumberMask = [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/];
